import { PackageLoadingSkeleton } from './PackageLoadingSkeleton';

export const WinePackagesLoadingSkeleton = () => {
  return (
    <div className='flex justify-center px-2 md:px-4 min-h-[200px] mx-auto w-full pt-2 mt-2 animate-pulse'>
      <div className='max-w-[1240px] md:px-2 justify-center w-full items-center lg:px-2'>
        <div className='h-5 w-52 bg-slate-200 rounded mt-3 mb-4'></div>
        <div className='px-2 flex items-center overflow-x-auto py-2 max-w-[1240px] w-full scrollbar scrollbar-width-2 scrollbar-thumb-slate-600 scrollbar-track-slate-300'>
          <PackageLoadingSkeleton />
          <PackageLoadingSkeleton />
          <PackageLoadingSkeleton />
          <PackageLoadingSkeleton />
          <PackageLoadingSkeleton />
        </div>
      </div>
    </div>
  );
};
